import { useEffect, useState } from 'react';
import {
    Badge,
    Button,
    Container,
    Icon,
    IconName,
    Stack,
    StackItem,
    Table,
    TableHeader,
    TableProvider,
} from '@optimus-web/core';
import { lt, useSafeUrlState, useToggle, useUrlSyncedTableState } from '@mews/framework';
import { QueryBoundary } from '@mews-commander/ui';
import { eqUniversal } from '@mews/fp';
import { useLedgerActivityTableMapping } from '../hooks/useRevenueTableMapping';
import { filtersSchema, LedgerActivityReportFilterValues, defaultLedgerActivityReportFilterValues } from '../schema';
import { LedgerActivityReportEntry, mockData } from './mockData';
import { LedgerActivityReportFilters } from './LedgerActivityReportFilters';

export const LedgerActivityReport = () => {
    const columns = useLedgerActivityTableMapping();
    const [urlState] = useSafeUrlState(filtersSchema);
    const [filterValues, setFilterValues] = useState<LedgerActivityReportFilterValues>(
        urlState || defaultLedgerActivityReportFilterValues
    );
    const [tableState, setTableState] = useUrlSyncedTableState<LedgerActivityReportEntry>({
        columns,
        extraQuery: filterValues,
    });
    const { pagination } = tableState;
    const { pageIndex, pageSize } = pagination;

    const data = mockData.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);
    const [open, toggleSidebar] = useToggle({ initialValue: false });
    const activeFilters =
        !eqUniversal.equals(filterValues, {}) &&
        !eqUniversal.equals(filterValues, defaultLedgerActivityReportFilterValues);

    useEffect(() => {
        setTableState({
            ...tableState,
            pagination: { ...tableState.pagination, pageIndex: 0 },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValues]);

    return (
        <Container padding={['0', '0', '200', '400']}>
            <QueryBoundary>
                <TableProvider columns={columns} state={tableState} onStateChange={setTableState}>
                    <Stack>
                        <StackItem grow>
                            <TableHeader
                                title="Ledger Activity Report"
                                subTitle="some date"
                                rightSide={
                                    <Container padding={['0', '300']}>
                                        <Button onClick={toggleSidebar} size="small" type="button">
                                            <Badge active={activeFilters} outline data-test-id="filters-applied-badge">
                                                <Icon value={IconName.Filter} size="small" />
                                            </Badge>
                                            {lt('Filter')}
                                        </Button>
                                    </Container>
                                }
                            />
                            <Table data={data} uniqueRowId="id" amountOfRows={mockData.length} />
                        </StackItem>
                        <LedgerActivityReportFilters
                            setFilterValues={setFilterValues}
                            open={open}
                            toggleSidebar={toggleSidebar}
                        />
                    </Stack>
                </TableProvider>
            </QueryBoundary>
        </Container>
    );
};
